import React from "react";
import { toHref } from "./resumeData";

// A section whose heading is kept together with its first item, so a heading
// is never stranded alone at the bottom of a page. Renders nothing when empty.
export const Section = ({ title, items, className = "rt-section" }) => {
  const list = items.filter(Boolean);
  if (!list.length) return null;
  const [first, ...rest] = list;
  return (
    <div className={className}>
      <div className="rt-avoid">
        {title}
        {first}
      </div>
      {rest.map((node, i) => (
        <React.Fragment key={i}>{node}</React.Fragment>
      ))}
    </div>
  );
};

export const LinkedInGithub = ({ data }) => {
  if (!data.linkedinId && !data.githubId) return null;
  return (
    <>
      {data.linkedinId && (
        <a href={toHref(data.linkedinId)} target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
      )}
      {data.linkedinId && data.githubId && " | "}
      {data.githubId && (
        <a href={toHref(data.githubId)} target="_blank" rel="noopener noreferrer">
          GitHub
        </a>
      )}
    </>
  );
};

export const EmailPhone = ({ data }) => {
  const parts = [data.email, data.phoneNo].filter(Boolean);
  return parts.length ? <>{parts.join(" | ")}</> : null;
};

export const eduLeft = (e) => [e.degree, e.institute].filter(Boolean).join(" | ");
export const eduRight = (e) => [e.score, e.year].filter(Boolean).join(" | ");

export const EduRow = ({ edu }) => (
  <div className="rt-row rt-avoid">
    <span>{eduLeft(edu)}</span>
    <span>{eduRight(edu)}</span>
  </div>
);

export const ExpBlock = ({ exp }) => (
  <div className="rt-avoid">
    <div className="rt-row">
      <span>{[exp.role, exp.company].filter(Boolean).join(" | ")}</span>
      <span>{exp.duration}</span>
    </div>
    {exp.description && <p>{exp.description}</p>}
  </div>
);

export const Bullets = ({ points }) =>
  points.length > 0 ? (
    <ul>
      {points.map((pt, i) => (
        <li key={i}>{pt}</li>
      ))}
    </ul>
  ) : null;

export const ProjectLink = ({ url }) =>
  url ? (
    <p>
      <a href={toHref(url)} target="_blank" rel="noopener noreferrer">
        Live Link
      </a>
    </p>
  ) : null;

export const MetaLine = ({ p }) => {
  const parts = [];
  if (p.projectRole)
    parts.push(
      <span key="r">
        <b>Role:</b> {p.projectRole}
      </span>,
    );
  if (p.technologiesUsed)
    parts.push(
      <span key="t">
        <b>Tech:</b> {p.technologiesUsed}
      </span>,
    );
  if (!parts.length) return null;
  return <p>{parts.reduce((acc, el, i) => (i ? [...acc, " | ", el] : [el]), [])}</p>;
};

export const SkillsTwoCol = ({ skills, className }) => (
  <div className={`rt-avoid ${className}`}>
    {[0, 1].map((col) => (
      <div key={col}>
        <ul>
          {skills
            .filter((_, i) => i % 2 === col)
            .map((s) => (
              <li key={s.key}>
                <strong>{s.key}: </strong>
                <span>{s.value}</span>
              </li>
            ))}
        </ul>
      </div>
    ))}
  </div>
);

export const SkillsKeyed = ({ skills }) => (
  <ul className="rt-avoid">
    {skills.map((s) => (
      <li key={s.key}>
        <strong>{s.key}: </strong>
        <span>{s.value}</span>
      </li>
    ))}
  </ul>
);

export const SkillsValuesOnly = ({ skills }) => (
  <ul className="rt-avoid">
    {skills.map((s) => (
      <li key={s.key}>
        <span>{s.value}</span>
      </li>
    ))}
  </ul>
);

export const Achievements = ({ others }) => (
  <ul>
    {others.map((o, i) => (
      <li key={i}>{o}</li>
    ))}
  </ul>
);